import { observer } from 'mobx-react-lite';
import React, { useMemo, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import { store, useStore } from '../../../../app/stores/store';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '50px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  // width: "890px",
  transition: 'border .24s ease-in-out',
};

const baseStyleError = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '50px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#9f3a38',
  borderStyle: 'dashed',
  backgroundColor: '#fff8f8',
  color: '#bdbdbd',
  outline: 'none',
  // width: "890px",
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const thumbsContainer: any = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
};

// const img = {
//   display: "flex",
//   width: "10%",
//   height: "10%",
// };

interface IImageUpload {
  files: File[];
  onDrop: (acceptedFiles: File[]) => void;
  error?: boolean;
  disableCheck?: boolean;
  elementName?: string;
}

const VerifyDragDrop: React.FC<IImageUpload> = ({
  files,
  onDrop,
  error,
  disableCheck,
  elementName,
}) => {
  const { commonStore } = useStore();
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: [
            'DCP Encrypted File Upload',
            'DCP Open File Upload',
            'ProRes UHD File Upload',
            'ProRes FHD File Upload',
            'MP4 File Upload',
            'MP4 watermark File Upload',
            'Ungraded RAWcooked File Upload',
            'DSM Seamless RAWcooked File Upload',
          ].includes(elementName || '')
        ? ['.html', '.htm', 'text/html']
        : ['Check Sum Upload', 'ProRes UHD Check Sum Upload', 'ProRes FHD Check Sum Upload', 'MP4 Check Sum Upload', 'MP4 watermark Check Sum Upload'].includes(elementName || "")
          ? ['.md5']
          : elementName === 'Restoration File Upload'
            ? ['.xlsx', '.xls']
          : commonStore.NFAIodsModel
           ? ['.ods']
          : ['.pdf', 'image/*', 'audio/*', 'video/*', '.xlsx', '.xls'],
    onDrop: onDrop,
  });

  const style: any = useMemo(
    () => ({
      ...(error ? baseStyleError : baseStyle),
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragAccept, isDragReject, error],
  );


  const thumbs = files.map((file: any) => (
    <div key={file.id}>
      <div>
        <img
          style={{
            display: 'flex',
            padding: '5px',
            overflow: 'scroll',
            paddingRight: '12px',
          }}
          src={
            file.type.includes('image') ? file.preview : '/assets/documents.jpg'
          }
          alt=""
          height="70px"
        />
        <p
          style={{
            color: 'black',
            alignItems: 'center',
            width: '100px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {file.name}
        </p>
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file: any) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  return (
    <div className={disableCheck ? 'component-isDisabled' : ''}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p //Drag and drop some files here, or click to select files
          style={{ color: error ? '#9f3a38' : 'black' }}
        >
          {[
            'DCP Encrypted File Upload',
            'DCP Open File Upload',
            'ProRes UHD File Upload',
            'ProRes FHD File Upload',
            'MP4 File Upload',
            'MP4 watermark File Upload',
            'Ungraded RAWcooked File Upload',
            'DSM Seamless RAWcooked File Upload',
          ].includes(elementName || '')
          ? 'kindly upload html, htm, text/html file.' 
          : ['Check Sum Upload', 'ProRes UHD Check Sum Upload', 'ProRes FHD Check Sum Upload', 'MP4 Check Sum Upload', 'MP4 watermark Check Sum Upload'].includes(elementName || "")
          ? 'kindly upload md5 file.'
          : elementName === 'Restoration File Upload'
           ? 'kindly upload xlsx, xls file.' 
          : store.commonStore.NFAIodsModel
            ? 'kindly upload ods file.'
            : (
                userLanguage[0].Level3InventoryRecievingVerify?.IRVFDL01 as any
              )?.[`${commonStore.language.key}`]}
        </p>
      </div>
      <aside style={thumbsContainer}>{thumbs}</aside>
    </div>
  );
};

export default observer(VerifyDragDrop);
